/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'

const messages: object = flatten({
	accueil: 'Accueil',
	parent: 'Parent',
	serviceWorker: {
		update: {
			title: 'Mettre à jour'
		},
		buttons: {
			update: 'Mettre à jour'
		},
		addApp: {
			buttons: 'Ajouter',
			title: 'Ajouter l\'application CodX Code sur l\'écran d\'accueil'
		},
		headPopin: 'Une nouvelle version disponible, vous devez mettre à jour votre version pour continuer d\'utiliser l\'application.'
	},
	global: {
		buttons: {
			cancel: 'Annuler',
			confirm: 'Confirmer',
			takePhoto: 'Prendre une photo',
			scanSpace: 'Scanner un espace',
			scanCode: 'Scanner un code',
			scanQrCode: 'Scanner un QR code',
			continueVisit: 'Reprendre la visite en cours',
			login: 'Se connecter',
			goBack: 'Retour',
			beginVisit: 'Commencer la visite',
			endVisit: 'Finaliser la visite',
			cancelVisit: 'Annuler la visite',
			replaceQrCode: 'Remplacer le QR code',
			scanEquipment: 'Scanner un équipement',
			linkCode: 'Associer le code',
			logout: 'Se déconnecter',
			validate: 'Valider',
			consultLegal: 'Consulter les mentions légales',
			consultSheet: 'Consulter la fiche',
			returnToVisit: 'Retour à la visite',
			addIntervention: 'Ajouter une intervention',
			replaceEquipmentQrCode: 'Remplacer le QR équipement',
			deleteEquipment: 'Supprimer l\'équipement',
			returnHome: 'Retour à l\'accueil',
			mailSupport: 'Contacter'
		},
		errors: {
			generic: 'Une erreur est survenue',
			login: 'L\'identifiant est obligatoire',
			password: 'Le mot de passe est obligatoire',
			loginForm: 'Mauvais couple identifiant / mot de passe',
			connection: 'Connexion impossible',
			spaceNotActive: 'Ce code a été désactivé',
			equipmentNotActive: 'Cet équipement a été désactivé',
			noPermission: 'Vous n\'avez pas les droits pour effectuer cette action',
			occurred: 'Une erreur est survenue',
			qrCodeLinked: 'Ce code est déjà associé à un logement',
			required: 'Ce champ est obligatoire',
			QRCODE_NOT_ACTIVE: 'Ce code n\'est pas actif',
			PERMISSION_DENIED: 'Vous n\'avez pas les droits pour effectuer cette action',
			EQUIPMENT_NOT_ACTIVE: 'Cet équipement n\'est pas actif',
			QRCODE_ALREADY_USED: 'Ce code est déjà utilisé',
			SPACE_NOT_ACTIVE: 'Ce logement n\'est pas actif',
			QRCODE_NOT_FOUND: 'QR Code non reconnu'
		}
	},
	login: {
		id: 'Identifiant',
		password: 'Mot de passe'
	},
	profile: {
		welcome: 'Bienvenue',
		title: 'Profil'
	},
	loading: {
		waiting: 'Veuillez patienter.',
		searching: 'Recherche en cours...'
	},
	scan: {
		equipment: {
			title: 'Le QR code est associé à un équipement',
			content: 'Voulez-vous effectuer une visite sur l\'espace associé à cet équipement ?'
		}
	},
	intervention: {
		subtitle: {
			equipment: 'Informations équipement',
			add: 'Ajouter une intervention',
			modify: 'Modifier une intervention'
		},
		fields: {
			type: 'Type d\'intervention',
			comment: 'Commentaire',
			selectLabel: {
				preventive: 'Maintenance préventive',
				curative: 'Maintenance curative',
				works: 'Travaux'
			}
		},
		popin: {
			title: 'Supprimer l\'intervention',
			content: 'Voulez-vous supprimer l\'intervention dans le cadre de cette visite ?'
		},
		buttons: {
			delete: 'Supprimer l\'intervention',
			validate: 'Valider l\'intervention',
			modify: 'Modifier l\'intervention',
			returnToEquipment: 'Retour à l\'équipement'
		},
		success: 'L\'intervention a été enregistrée'
	},
	visit: {
		found: 'Logement trouvé.',
		equipmentFound: 'Équipement trouvé.',
		linked: 'Logement associé.',
		subtitle: {
			info: 'Informations logement',
			intervention: 'Intervention en cours',
			linkedEquipment: 'Equipements associés'
		},
		houseInfo: {
			buildingProgramName: 'Programme immobilier',
			buildingNumber: 'Bâtiment',
			entryName: 'Entrée',
			spaceNumber: 'Espace'
		},
		equipmentInfo: {
			brand: 'Marque',
			id_brand: 'Id Marque',
			commissioningDate: 'Date de mise en service',
			model: 'Modèle',
			id_model: 'Id Modèle',
			serialNumber: 'Numéro de série',
			type: 'Type',
			id_type: 'Id Type',
			documents: 'Documentation',
			visitDate: 'Date dernière visite périodique',
			latestWorksInterventionDate: 'Date derniers travaux',
			latestCurativeInterventionDate: 'Date dernière réparation',
			document: 'Document {index}'

		},
		replaceQrCode: {
			success: 'Le code a bien été remplacé',
			qrCodeUsed: 'Ce code est déjà utilisé'
		},
		noIntervention: 'Aucune intervention en cours, veuillez scanner un équipement.',
		noEquipment: 'Aucun équipement associé.',
		buttons: {
			return: 'Retourner à la visite',
			end: 'Terminer la visite'
		},
		cancelVisit: {
			title: 'Abandon de la visite',
			content: 'Voulez-vous abandonner la visite ?'
		},
		endVisit: {
			title: 'Finalisation de la visite',
			fields: {
				comment: 'Commentaire',
				interventionNumber: 'Numéro d\'intervention'
			},
			intervention: 'Intervention',
			confirmed: 'confirmée.'
		},
		pending: {
			title: 'Visite en cours',
			content: 'Attention, vous avez déjà une visite en cours. Voulez-vous supprimer cette visite et en effectuer une nouvelle ?'
		}
	},
	linkSpace: {
		title: 'Associer un espace',
		fields: {
			buildingProgramName: 'Nom du programme immobilier',
			buildingNumber: 'Numéro de bâtiment',
			buildingEntry: 'Entrée',
			spaceNumber: 'Espace'
		},
		popin: {
			title: 'L\'espace possède un QR code',
			text: 'Attention, cet espace dispose déjà d\'un QR code. Voulez-vous le remplacer ? L\'ancien QR code sera désactivé.'
		}
	},
	linkEquipment: {
		title: 'Associer un QR code pour cet équipement',
		header: 'Equipement non trouvé',
		fields: {
			brand: 'Marque',
			commissioningDate: 'Date de mise en service',
			model: 'Modèle',
			serialNumber: 'Numéro de série',
			type: 'Type'
		}
	},
	topBar: {
		activateDarkMode: 'Activer le mode sombre'
	},
	form: {
		datePickerTitle: 'Sélectionner une date',
		optional: 'facultatif'
	}
})
export default messages
